<template>
  <div class="edit-option" :style="{ color: isSelected ? 'white' : '#ccc' }">
    <el-button
      class="edit-option__btn"
      :disabled="disabledBtn"
      :style="{ color: isSelected ? 'white' : '#ccc' }"
      @click="$emit('click')"
    >
      <!-- tab icon image -->
      <slot name="icon"></slot>
    </el-button>
    <!-- tab label text -->
    <slot name="label"></slot>
  </div>
</template>

<script>
// @group Editing
// Edit tool tab
export default {
  name: "EditToolTab",
  props: {
    // is this tab selected
    isSelected: {
      type: Boolean,
      default: false
    },
    disabledBtn: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-option__btn{
  background: #ed5229;
}

.edit-option {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__btn {
    margin-bottom: 5px;
    width: fit-content;
  }
}
</style>
